// utils/usersService.js

import utils from "../utils/utils";


export const BOAPI = {
  // משתמשים
  fetchUsers: () => utils.requestData('BOGetUsers', {}),
  setUserRole: (userId, role) => utils.requestData('BOSetUserRole', { userId, role }),
  // מחיקה קשיחה - חסומה בשרת אם למשתמש יש היסטוריית עסקאות/בעלות על בית
  // עסק/הצעת בית עסק (ראו spBODeleteUser) - לשימוש הרגיל יש להשבית (role/isActive)
  deleteUser: (id) => utils.requestData('BODeleteUser', { id }),
  // יצירת חשבון משתמש-אתר (role='owner') ישירות מהבק אופיס - בעיקר לזרימת
  // שיוך בעלים בעת הוספת בית עסק, ראו BusinessEditModal.jsx
  createUser: (params) => utils.requestData('BOCreateUser', params),
  // אישורי תקנון/מדיניות פרטיות של משתמש (UserConsents)
  fetchUserConsents: (userId) => utils.requestData('BOGetUserConsents', { userId }),

  // פעילויות
  fetchAllActivities: (range) => utils.requestData('BOGetAllActivities', range || {}),
  fetchUserActivities: (userId, range) => utils.requestData('BOGetUserActivities', { userId: parseInt(userId, 10), ...(range || {}) }),

  // דשבורד
  fetchDashboard: (range) => utils.requestData('BODashboard', range || {}),

  // בתי עסק (Businesses) - הרשימה הפעילה. "השתקה"/"שחזור" בממשק = toggleBusinessActive
  // (השבתה, לא DELETE אמיתי - ראו BOToggleBusinessActive ב-BO.sql). deleteBusiness =
  // מחיקה קשיחה אמיתית (spBODeleteBusiness) - חסומה בשרת אם כבר הונפקו לבית העסק עסקאות
  fetchBusinesses: () => utils.requestData('BOGetBusinesses', {}),
  addBusiness: (params) => utils.requestData('BOAddBusiness', params),
  updateBusiness: (params) => utils.requestData('BOUpdateBusiness', params),
  toggleBusinessActive: (id) => utils.requestData('BOToggleBusinessActive', { id }),
  deleteBusiness: (id) => utils.requestData('BODeleteBusiness', { id }),
  importBusinesses: (items) => utils.requestData('BOImportBusinesses', { items }),
  // ייבוא ישיר ל-Businesses בסטטוס "ממתין לאישור בעלים" (עם confirmToken
  // לכל שורה) - ראו הערה מלאה ב-spBOImportPendingBusinesses/BO.sql
  importPendingBusinesses: (items) => utils.requestData('BOImportPendingBusinesses', { items }),
  // מעקב ידני לעסק ממתין - "סירב"/"לחזור בעוד חודש" וכו'. followUpAt/
  // followUpNote null+null מנקה מעקב קיים
  setBusinessFollowUp: (businessId, followUpAt, followUpNote) =>
    utils.requestData('BOSetBusinessFollowUp', { businessId, followUpAt, followUpNote }),

  // בתי עסק שהוגשו דרך האפליקציה (spSubmitBusiness) - ממתינים לאישור
  fetchBusinessSubmissions: (status) => utils.requestData('BOGetBusinessSubmissions', status ? { status } : {}),
  approveBusinessSubmission: (id) => utils.requestData('BOApproveBusinessSubmission', { id }),
  rejectBusinessSubmission: (id, reason) => utils.requestData('BORejectBusinessSubmission', { id, reason }),

  // קטגוריות בתי עסק - ניתנות להרחבה (לא clothing/footwear/both קשיחים
  // יותר), ראו BusinessCategories ב-Tables.sql
  fetchBusinessCategories: () => utils.requestData('GetBusinessCategories', {}),
  addBusinessCategory: (params) => utils.requestData('BOAddBusinessCategory', params),

  // הודעות/פרסומות - מסך הפתיחה של האפליקציה (announcements.tsx)
  fetchAnnouncements: () => utils.requestData('BOGetAnnouncements', {}),
  addAnnouncement: (params) => utils.requestData('BOAddAnnouncement', params),
  updateAnnouncement: (params) => utils.requestData('BOUpdateAnnouncement', params),
  toggleAnnouncementActive: (id) => utils.requestData('BOToggleAnnouncementActive', { id }),

  // צור קשר - פניות חופשיות ממשתמשים (contactUs.tsx באפליקציה)
  fetchContactMessages: () => utils.requestData('BOGetContactMessages', {}),
  markContactMessageHandled: (id) => utils.requestData('BOMarkContactMessageHandled', { id }),

  // הודעות לבתי עסק - מוצגות באפליקציה לבעלים/מנהלים של בית העסק בלבד
  fetchBusinessMessages: (businessId) => utils.requestData('BOGetBusinessMessages', businessId ? { businessId } : {}),
  sendBusinessMessage: (params) => utils.requestData('BOSendBusinessMessage', params),
  toggleBusinessMessageActive: (id) => utils.requestData('BOToggleBusinessMessageActive', { id }),

  // שליחת התראות Push - userIds ריק/undefined = כל המשתמשים עם התראות פעילות
  sendPushNotification: (params) => utils.requestData('BOSendPushNotification', params),

  // קונפיגורציה - הגדרות מערכת גלובליות (key-value), ראו AppSettings ב-Tables.sql
  fetchAppSettings: () => utils.requestData('BOGetAppSettings', {}),
  updateAppSetting: (key, value) => utils.requestData('BOUpdateAppSetting', { key, value }),

  // ימי פעילות - לוח שנה עם חריגים מברירת המחדל (א'-ו' פעיל, שבת לא), ראו AppActivityDays ב-Tables.sql
  fetchActivityCalendar: (from, to) => utils.requestData('BOGetActivityCalendar', { from, to }),
  setActivityDay: (day, isActive, note) => utils.requestData('BOSetActivityDay', { day, isActive, note }),

  // דירוגים/תגובות על בתי עסק - ניהול (הסתרה/הצגה, לא מחיקה), admin בלבד
  fetchBusinessReviews: (includeHidden) => utils.requestData('BOGetBusinessReviews', { includeHidden: includeHidden ? 1 : 0 }),
  toggleBusinessReviewActive: (id) => utils.requestData('BOToggleBusinessReviewActive', { id }),

  // התנתקות - מבטלת את הטוקן בפועל בשרת (לא רק ניקוי מקומי)
  logout: () => utils.requestData('BOLogout', {}),

  // צוות הבק אופיס עצמו (BOUsers) - לא לבלבל עם fetchUsers/setUserRole למעלה
  // (משתמשי האתר/אפליקציה). admin בלבד - נאכף בשרת
  fetchBOUsers: () => utils.requestData('BOGetBOUsers', {}),
  createBOUser: (params) => utils.requestData('BOCreateBOUser', params),
  updateBOUser: (params) => utils.requestData('BOUpdateBOUser', params),
};

class UsersService {
  users = null;

  async getUsers(fetcher) {
    if (this.users) return this.users;
    const data = await fetcher();
    this.users = data;
    return data;
  }

  removeUser(userId) {
    this.users = this.users?.filter(u => u.id !== userId);
  }

  clear() {
    this.users = null;
  }
}

export default new UsersService();
